import { useEffect, useState } from 'react';
import classNames from 'classnames';

import XIcon from '~/components/atoms/Icons/XIcon';

import { TUseBooleanState } from '~/hooks/useBooleanState';
import { SlotsContext, TSlotsContextState } from '~/redux/slices/slotsFilters';
import { useAppDispatch } from '~/redux/store/useAppDispatch';

import Filters from './Filters';
import SearchWithHistory from './SearchWithHistory';

import styles from './SearchAndFilters.module.scss';

interface ISearchAndFilters {
  searchBooleanState: TUseBooleanState;
  contexFunctions: TSlotsContextState;
}

export default function SearchAndFilters({
  searchBooleanState: [visible, { setFalse }],
  contexFunctions,
}: ISearchAndFilters): JSX.Element | null {
  const [isDisplayed, setDisplayed] = useState(visible);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!visible) {
      // @ts-ignore quick fix for the release, fix in the future
      dispatch(contexFunctions.resetFiltersAndSearch());
    }
  }, [contexFunctions, dispatch, visible]);

  useEffect(() => {
    if (visible) {
      setDisplayed(true);
    }
  }, [visible]);

  return (
    <SlotsContext.Provider value={contexFunctions}>
      <div
        className={classNames(styles.content, visible && styles.contentVisible)}
        onTransitionEnd={() => {
          if (!visible) {
            setDisplayed(false);
          }
        }}
      >
        <div
          className={classNames(
            styles.searchWrapper,
            visible && styles.visible,
          )}
        >
          {isDisplayed && (
            <>
              <XIcon
                className={styles.clean}
                onClick={setFalse}
              />
              <SearchWithHistory />
            </>
          )}
        </div>
        {isDisplayed && <Filters visible={visible} />}
      </div>
    </SlotsContext.Provider>
  );
}
